export default {
  // 表格列标题
  counterparty: "交易对手",
  inflowAmount: "转入数量(USDT)",
  inflowCount: "转入次数(USDT)",
  outflowAmount: "转出数量(USDT)",
  outflowCount: "转出次数(USDT)",

  // 加载和状态
  loading: "拼命加载中",
  noData: "暂无数据",

  // 下载
  downloadDetails: "下载数据明细",
  downloadNote: "注：最多可下载10万条数据",

  // 消息提示
  copySuccess: "复制成功",
};
